import { Component, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { AppConfigService } from '../../Services/app-config.service';
import { EnrichmentGuidePOIPCSNearShipsService } from 'src/app/Services/enrichment-guide-poipcsnear-ships.service';
import { UserData } from 'src/app/Models/employee-and-user-data';
import { EnrichmentGuidePOI, EnrichmentGuidePageData } from 'src/app/Models/enrichment-guide-poi';
import { Subject, interval } from 'rxjs';
import { switchMap, takeUntil } from 'rxjs/operators';
import { TripContextService } from 'src/app/Services/trip-context.service';

@Component({
  selector: 'app-enrichment-guide-pointsofinterest-page',
  templateUrl: './enrichment-guide-pointsofinterest-page.component.html',
  styleUrls: ['./enrichment-guide-pointsofinterest-page.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EnrichmentGuidePointsofinterestPageComponent implements OnInit, OnDestroy {

  shpID: number | undefined;
  shipname: string | undefined;

  viewallpointsofinterest = false;
  pagemask: boolean | undefined;

  ShipCoordData?: any;

  userdata: UserData | undefined;

  nearbypointsofinterest: EnrichmentGuidePOI[] = [];
  visiblepointsofinterest: EnrichmentGuidePOI[] = [];
  interesttopics: EnrichmentGuidePOI[] = [];

  statusR: boolean | undefined;
  loadError = false;

  private destroy$ = new Subject<void>();
  private refresh$ = new Subject<void>();

  constructor(
    private appConfigService: AppConfigService,
    private enrichmentGuidePOIService: EnrichmentGuidePOIPCSNearShipsService,
    private tripContextService: TripContextService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    const refreshWindow = this.appConfigService.EnrichmentGuideRefreshWindow;

    try {
      this.userdata = JSON.parse(localStorage.getItem('userinfo') || '{}');
    } catch {
      this.userdata = undefined;
    }
    this.shpID = this.userdata?.shipid;
    this.shipname = this.userdata?.ShipName;

    this.pagemask = this.tripContextService.resolve(this.userdata).pagemask;
    if (this.pagemask === false) {
      this.setupPolling(refreshWindow);
      this.refresh$.next();
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  loadData(): void {
    this.refresh$.next();
  }

  trackByPoi(index: number, poi: EnrichmentGuidePOI): number {
    return poi.egpMileMarkerId;
  }

  private setupPolling(refreshWindow: number): void {
    this.refresh$.pipe(
      switchMap(() => this.enrichmentGuidePOIService.loadPageData(this.shpID)),
      takeUntil(this.destroy$)
    ).subscribe({
      next: (data: EnrichmentGuidePageData) => {
        this.applyPageData(data);
        this.cdr.markForCheck();
      },
      error: (err) => {
        console.error(err);
        this.loadError = true;
        this.cdr.markForCheck();
      }
    });

    interval(refreshWindow).pipe(
      takeUntil(this.destroy$)
    ).subscribe(() => this.refresh$.next());
  }

  private applyPageData(data: EnrichmentGuidePageData): void {
    this.loadError = false;
    this.statusR = data.statusR;
    this.nearbypointsofinterest = data.nearbypointsofinterest;
    this.visiblepointsofinterest = data.visiblepointsofinterest;
    this.interesttopics = data.interesttopics;
    this.ShipCoordData = data.shipCoordData;
  }
}
